"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _textMaskCore = require("text-mask-core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _alignments = require("../../../../constants/alignments");

var _displayModes = require("../../../../constants/displayModes");

var _widths = require("./widths");

var _Common = require("./Common.styles");

var _defaultMaskOptions = require("./defaultMaskOptions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewInput = _react.default.memo(function (_ref) {
  var aligninput = _ref.aligninput,
      inputWidth = _ref.inputWidth,
      mask = _ref.mask,
      mode = _ref.mode,
      value = _ref.value,
      zeroPadding = _ref.zeroPadding;
  var inViewMode = mode === _displayModes.displayModes.viewing || mode === _displayModes.displayModes.viewOnly;
  return /*#__PURE__*/_react.default.createElement(_Common.StyledViewWrapper, {
    alignment: aligninput,
    dataTestId: "input-view-mode-text",
    inputWidth: inputWidth,
    inViewMode: inViewMode,
    zeroPadding: zeroPadding
  }, mask ? (0, _textMaskCore.conformToMask)("".concat(value), mask, _defaultMaskOptions.defaultMaskOptions).conformedValue : value);
});

ViewInput.propTypes = {
  /** Alignment of the input area - primarily used when doing split layouts */
  aligninput: _propTypes.default.oneOf([undefined, _alignments.alignments.left, _alignments.alignments.right, _alignments.alignments.center]),

  /** width of the input - defaults to our traditional 100% width input */
  inputWidth: _propTypes.default.oneOf([undefined, _widths.inputWidths.default, _widths.inputWidths.fitText]),

  /** Mask for input overlay */
  mask: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.bool, _propTypes.default.func]),

  /** Mode flag
   * - 'editOnly' for single mode, editable
   * - 'viewing' for dual mode, starting in a 'viewing' state
   * - 'viewOnly' for single mode, not editable
   */
  mode: _propTypes.default.oneOf([undefined, _displayModes.displayModes.editing, _displayModes.displayModes.editOnly, _displayModes.displayModes.viewing, _displayModes.displayModes.viewOnly]),

  /** This is the storage location for the value of the input */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** flag to partially remove default padding - used internally */
  zeroPadding: _propTypes.default.bool
};
ViewInput.defaultProps = {
  aligninput: _alignments.alignments.left,
  inputWidth: _widths.inputWidths.default,
  mask: false,
  mode: _displayModes.displayModes.editOnly,
  value: '',
  zeroPadding: false
};
var _default = ViewInput;
exports.default = _default;